import React from "react";
import { EmptyState } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import TrendLine from "../../../../ForBrands/ui/charts/TrendLine";
import { ROLE } from "../../../../ForBrands/ui/charts/chartTokens";
import { signed1 } from "../../../../../utils/perfFormat";
import { formTitle, formView, resultWord } from "../teamPerformanceModel";
import { CardNote, DetailLines, Figure } from "./perfPieces";

// Form: Net Rating ({N}-Game Rolling) (BUILD_SPEC B7, Jayson's T5): the
// current rolling Net and the season Net up top, then the rolling line
// (bm-ink, B18) over single-game dots, green at or above zero and red
// below. Each game opens its detail: a hover card on hover or keyboard
// focus (desktop), a readout above the chart after a tap (phones). The
// window comes from the payload, never a fixed 5.

const NetFormCard = ({ payload, collapse }) => {
  const view = formView(payload);
  const rollingWindow = view.window;
  const rollingName = rollingWindow ? `Rolling ${rollingWindow}-game Net` : "Rolling Net";
  const detail = (i) => {
    const p = view.points[i];
    if (!p) return null;
    const word = resultWord(p.result);
    return (
      <DetailLines
        title={`${p.label}${p.opponent ? ` vs ${p.opponent}` : ""}`}
        sub={word ? `${word} ${p.score}` : null}
        rows={[
          ["Game Net", signed1(p.value)],
          [rollingName, signed1(p.rolling)],
        ]}
      />
    );
  };
  const legend = [
    { key: "rolling", swatch: "line", color: ROLE.trend, label: rollingName },
    { key: "up", swatch: "dot", color: ROLE.better, label: "Game at or above 0" },
    { key: "down", swatch: "dot", color: ROLE.worse, label: "Game below 0" },
  ];
  return (
    <CollapsibleCard title={formTitle(rollingWindow)} titleAs="h3" {...collapse}>
      <div className="flex items-start justify-between gap-4">
        <Figure eyebrow="Current form" value={signed1(view.current)} toneValue={view.current} />
        <Figure eyebrow="Season Net" value={signed1(view.season)} toneValue={view.season} align="right" />
      </div>
      {view.points.length ? (
        <>
          <TrendLine
            points={view.points}
            renderDetail={detail}
            label="Games"
            ariaLabel={`${rollingName} by game over ${view.points.length} games, now ${signed1(view.current)}; season Net ${signed1(view.season)}`}
          />
          <LegendRow items={legend} label="Form legend" />
          <CardNote>Single games are clipped at ±40 so one blowout does not flatten the line.</CardNote>
        </>
      ) : (
        <EmptyState>The form line appears once games have box scores.</EmptyState>
      )}
    </CollapsibleCard>
  );
};

export default NetFormCard;
